import ProviderNoteFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ProviderNoteApi, ProviderNoteDataType } from "@/api/ProviderNoteApi";
import { useEffect, useRef, useState } from "react";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import { ProviderNoteFormData, ProviderNoteRelatedAttributes } from "@/formTypes/ProviderNoteFormDataType";
import { ProviderInvoiceDataType } from "@/api/ProviderInvoiceApi";
import LoadXmlDataForm from "@components/dynamic/LoadXmlDataForm";
import LoadingScreen from "@components/content/LoadingScreen";
import { loadXmlDocument } from "@utils/EDocument";
import { omitProperties } from "@utils/Utils";
import { showAlert } from "@utils/Alert";
import { PROVIDER_CREDITNOTE_TYPE_CODE, PROVIDER_DEBITNOTE_TYPE_CODE } from "@utils/Constants";

type ProviderNoteFormProps = {
  id?: string;
  providerInvoice?: ProviderInvoiceDataType;
  currencyId?: string;
  formId: string,
  saveRedirectUrl: string
}

const ProviderNoteForm = (props: ProviderNoteFormProps) => {
  const { providerInvoice } = props;
  const formRef = useRef<DynamicFormRef>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (providerInvoice?.currencyId) {
      CurrencyIdPubSub.publish({ currencyId: providerInvoice?.currencyId, forceUpload: false })
    }
  }, [])

  const onXMLFileLoad = async (fileData: unknown) => {
    setIsLoading(true)
    try {
      const { documentData, documentSummary } = await loadXmlDocument(fileData, ["NotaCreditoElectronica", "NotaDebitoElectronica"])

      const providerInvoiceData = omitProperties(documentData || {}, ["Products", "identificacion", "providerId", "pagada"])

      const defaultData: Partial<ProviderNoteDataType> = {
        ...providerInvoiceData,
        providerInvoiceId: providerInvoice?.id,
        tipo: documentSummary?.documentType == "NotaCreditoElectronica" ? `${PROVIDER_CREDITNOTE_TYPE_CODE}` : `${PROVIDER_DEBITNOTE_TYPE_CODE}`
      }
      formRef.current?.resetFormValue(defaultData);
    } catch (err) {
      if (err instanceof Error) {
        showAlert("danger", err.message)
      }
    }
    finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <LoadXmlDataForm
        onFileLoaded={onXMLFileLoad}
      />
      <GenericForm<ProviderNoteFormData, ProviderNoteDataType>
        id={props.id}
        ref={formRef}
        formId={props.formId}
        defaultData={{
          providerInvoiceId: props.providerInvoice?.id,
          currencyId: `${props.providerInvoice?.currencyId}`,
          exchange_rate: props.providerInvoice?.exchange_rate
        }}
        saveRedirectUrl={props.saveRedirectUrl}
        modelRelativeObjects={ProviderNoteRelatedAttributes}
        formConfig={ProviderNoteFormConfig}
        getById={(...arg) => ProviderNoteApi.get(...arg)}
        createFn={(...arg) => ProviderNoteApi.create(...arg)}
        updateFn={(...arg) => ProviderNoteApi.update(...arg)}
        successMessage="La nota ha sido agregada correctamente a la Factura del Provedor"
        errorMessage="No fue posible almacenar la nota a la Factura del Provedor"
      />
      <LoadingScreen isLoading={isLoading} />
    </>
  )
}

export default ProviderNoteForm;